export default __webpack_public_path__ + "static/media/ticket.3881cc72.png";